import React from "react";
import { MapTool } from "./__styles__/MapTools";
import { MapToolLabel } from "./MapToolLabel";

type ButtonConfig = {
  iconClass: string;
  onClick: () => void;
  label: string;
};

type MapboxButtonMimicProps = {
  buttons: ArrayWithAtLeastOneItem<ButtonConfig>;
  showLabel?: boolean;
};

// Mapbox GL JS controls render into fixed position containers (top-left, top-right,
// bottom-left, bottom-right) managed by the map. react-map-gl's controls inherit this
// behavior, making custom positioning impossible.
//
// This component mimics Mapbox control styling by using their CSS classes while
// rendering in normal document flow, allowing us to position controls wherever needed.
// The mapbox-gl stylesheet provides the button styling and icons via these classes.
export const MapboxButtonMimic = ({
  buttons,
  showLabel = false,
}: MapboxButtonMimicProps) => {
  return (
    <MapTool>
      {showLabel && <MapToolLabel label={buttons[0].label} />}
      <div className="mapboxgl-ctrl mapboxgl-ctrl-group">
        {buttons.map(({ iconClass, onClick, label }) => (
          <button
            key={iconClass}
            className={iconClass}
            type="button"
            title={label}
            aria-label={label}
            onClick={onClick}
          >
            <span className="mapboxgl-ctrl-icon" aria-hidden="true" />
          </button>
        ))}
      </div>
    </MapTool>
  );
};
